<div class="admin-dialog">
  <!-- Header -->
  <div class="admin-dialog__header">
    <div class="admin-dialog__header-left">
      <h2 class="admin-dialog__title" i18n="@@adminSystem.systemAdminDetails.title.info">システム管理者情報</h2>
    </div>
    <button mat-icon-button class="admin-dialog__close" (click)="onNoClick()" aria-label="Close dialog" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="admin-dialog__content">
    <form [formGroup]="adminFormGroup">

      @if (mode == Mode.disp || mode == Mode.edit) {
        <div class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text" i18n="@@adminSystem.systemAdminDetails.label.name">氏名</span>
            <span class="form-label__required">*</span>
          </div>
          <div class="admin-dialog__field-row">
            <mat-form-field appearance="outline" class="form-field form-field--half">
              <mat-label i18n="@@adminSystem.systemAdminDetails.label.lastName">姓</mat-label>
              <input matInput formControlName="lastName" />
              <mat-icon matSuffix class="material-icons-outlined">person</mat-icon>
              @if (adminFormGroup.get('lastName')?.hasError('required')) {
                <mat-error i18n="@@adminSystem.systemAdminDetails.error.required">必須項目です</mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field form-field--half">
              <mat-label i18n="@@adminSystem.systemAdminDetails.label.firstName">名</mat-label>
              <input matInput formControlName="firstName" />
              @if (adminFormGroup.get('firstName')?.hasError('required')) {
                <mat-error i18n="@@adminSystem.systemAdminDetails.error.required">必須項目です</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      }

      @if (mode == Mode.invite) {
        <div class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text" i18n="@@adminSystem.systemAdminDetails.label.email">メールアドレス</span>
            <span class="form-label__required">*</span>
          </div>
          <mat-form-field appearance="outline" class="form-field">
            <input matInput type="email" formControlName="email" i18n-placeholder="@@adminSystem.systemAdminDetails.placeholder.email" />
            <mat-icon matSuffix class="material-icons-outlined">mail</mat-icon>
            @if (adminFormGroup.get('email')?.hasError('required')) {
              <mat-error i18n="@@adminSystem.systemAdminDetails.error.required">必須項目です</mat-error>
            }
            @if (adminFormGroup.get('email')?.hasError('email')) {
              <mat-error i18n="@@adminSystem.systemAdminDetails.error.emailFormat">メールアドレスのフォーマットが誤っています</mat-error>
            }
          </mat-form-field>
        </div>
      }

      <div class="admin-dialog__section">
        <div class="form-label">
          <span class="form-label__text" i18n="@@adminSystem.systemAdminDetails.label.roles">権限</span>
        </div>
        <div class="role-checkboxes">
          @for (role of common.systemAdminRoles; track role.code) {
            <label class="role-checkbox">
              <mat-checkbox [formControlName]="role.code" color="primary"></mat-checkbox>
              <span class="role-checkbox__label">{{ role.desc }}</span>
            </label>
          }
        </div>
      </div>

      @if (mode == Mode.disp || mode == Mode.edit) {
        <div class="admin-dialog__divider"></div>

        <div class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text" i18n="@@adminSystem.systemAdminDetails.label.status">ステータス</span>
          </div>
          <mat-radio-group formControlName="status" class="form-radio-group">
            @for (st of common.Status; track st) {
              <mat-radio-button [value]="st.code.toUpperCase()" color="primary">{{ st.desc }}</mat-radio-button>
            }
          </mat-radio-group>
        </div>

        <div class="admin-dialog__field-row">
          <div class="admin-dialog__section" style="flex: 1;">
            <div class="form-label form-label--small">
              <span class="form-label__text" i18n="@@adminSystem.systemAdminDetails.label.accountId">アカウントID</span>
            </div>
            <mat-form-field appearance="outline" class="form-field">
              <input matInput formControlName="userId" placeholder="--" i18n-placeholder="@@adminSystem.systemAdminDetails.placeholder.accountId" />
              <mat-icon matSuffix class="material-icons-outlined">badge</mat-icon>
            </mat-form-field>
          </div>
          <div class="admin-dialog__section" style="flex: 1;">
            <div class="form-label form-label--small">
              <span class="form-label__text" i18n="@@adminSystem.systemAdminDetails.label.assignedDate">管理者 開始日</span>
            </div>
            <mat-form-field appearance="outline" class="form-field">
              <input matInput formControlName="assignedDate" placeholder="--/--/--" i18n-placeholder="@@adminSystem.systemAdminDetails.placeholder.assignedDate" />
              <mat-icon matSuffix class="material-icons-outlined">calendar_today</mat-icon>
            </mat-form-field>
          </div>
        </div>
      }

    </form>
  </div>

  <!-- Footer -->
  <div class="admin-dialog__footer">
    @if (!changesMade) {
      <button mat-stroked-button (click)="onNoClick()">
        <span i18n="@@adminSystem.systemAdminDetails.button.close">閉じる</span>
      </button>
    } @else {
      <button mat-stroked-button color="warn" (click)="onNoClick()">
        <span i18n="@@adminSystem.systemAdminDetails.button.discard">破棄</span>
      </button>
    }
    <button mat-flat-button color="primary" (click)="onEditOrUploadClicked()">
      <span i18n="@@adminSystem.systemAdminDetails.button.action">{{ mode === Mode.disp ? '編集' : mode === Mode.edit ? '保存' : '招待' }}</span>
    </button>
  </div>
</div>
